import React from 'react';
import {
  FeatureSection,
  Container,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  HeaderDescription,
  Grid,
  CategoryCard,
  UniverseBox,
  UniverseLeft,
  UniverseRight,
  UniverseBadge,
  UniverseTitle,
  UniverseText,
  ButtonRow,
  UniverseButton,
  StatsRow,
  StatItem,
  CardStack,
  CardItem,
  MarqueeWrapper,
  MarqueeTrack,
  LocationCard,
  LocationSection,
  ShopButton
} from './MinggoFeature.styles';
import MinggoCarousel from './MinggoCarousel';

const categories = [
  {
    title: 'School Essentials',
    description: 'Bags, Stationery, Sippers, Lunch Box, Water Bottles, and many more...',
  },
  {
    title: 'Birthday & Party',
    description: 'Decoration, Return gifts, Miscellaneous party items, and many more...',
  },
  {
    title: 'Infant & Newborn',
    description: 'Prams, Walkers, Baby carrier, Bath & Skincare, Clothes, Diapers, Feeding items, furniture, ride-ons, Tricycles, and many more...',
  },
  {
    title: 'Bikes & Cars',
    description: 'Ride-on toys, toy vehicles, and play sets for kids of all ages.',
  },
  {
    title: 'Games & Outdoor Play',
    description: 'Board games, outdoor games, puzzles, and action toys.',
  },
  {
    title: 'Treats & Refreshments',
    description: 'Chocolates, Ice-Cream, and Baskin Robbins.',
  },
  {
    title: 'Home Decor',
    description: 'Decorative items and home accessories for gifting and celebrations.',
  },
  {
    title: 'Gifting Items',
    description: 'Curated gift options for birthdays, festivals, and special occasions.',
  },
  {
    title: 'Swimming Accessories',
    description: 'Swimwear and pool essentials for children.',
  },
];

const MinggoFeature = () => {
  return (
    <FeatureSection id="minggo-store">
      <Container>
        <Header>
          <HeaderTitle>MinGGo Nagpur</HeaderTitle>
          <HeaderSubtitle>Premium Toys, Baby Care & Kids Essential</HeaderSubtitle>
          <HeaderDescription>
            Shop toys, infant products, educational games, school supplies, birthday gifts, and family essentials at MinGGo Nagpur.
            Discover exciting collections for every age with quality products, affordable prices, and a joyful shopping experience for families.
          </HeaderDescription>
        </Header>

        <MinggoCarousel />

        <UniverseBox>
          <UniverseLeft>
            <UniverseBadge>Nagpur’s Favorite Kids Store</UniverseBadge>
            <UniverseTitle>Everything Kids Love, All in One Place</UniverseTitle>
            <UniverseText>
              Toys, baby care, school essentials, birthday gifts & family shopping — curated for joyful childhood moments.
            </UniverseText>
            <ButtonRow>
              <UniverseButton href="#minggo-store">Explore Collections</UniverseButton>
              <UniverseButton
                href="https://www.minggo.in"
                target="_blank"
                rel="noopener noreferrer"
                secondary
              >
                Visit Store
              </UniverseButton>
            </ButtonRow>
            <StatsRow>
              <StatItem>
                <strong>5000+</strong>
                <span>Happy Families</span>
              </StatItem>
              <StatItem>
                <strong>1000+</strong>
                <span>Toys & Essentials</span>
              </StatItem>
              <StatItem>
                <strong>Trusted</strong>
                <span>Local Store</span>
              </StatItem>
            </StatsRow>
          </UniverseLeft>

          <UniverseRight>
            <CardStack>
              <CardItem className="card-one">
                <strong>🎁</strong>
                <h4>Toys</h4>
                <p>Playsets, action figures, and creative fun.</p>
              </CardItem>
              <CardItem className="card-two">
                <strong>🎒</strong>
                <h4>School Essentials</h4>
                <p>Bags, stationery, books, and study must-haves.</p>
              </CardItem>
              <CardItem className="card-three">
                <strong>🍼</strong>
                <h4>Baby Care</h4>
                <p>Soft essentials, feeding, hygiene, and comfort.</p>
              </CardItem>
              <CardItem className="card-four">
                <strong>🎈</strong>
                <h4>Birthday & Gifts</h4>
                <p>Party bundles, return gifts, and celebration picks.</p>
              </CardItem>
            </CardStack>
          </UniverseRight>

          <MarqueeWrapper>
            <MarqueeTrack>
              <span>Remote Cars • Dolls • School Bags • Walkers • Return Gifts • Board Games • Baby Care</span>
              <span>Remote Cars • Dolls • School Bags • Walkers • Return Gifts • Board Games • Baby Care</span>
            </MarqueeTrack>
          </MarqueeWrapper>
        </UniverseBox>

        <Grid>
          {categories.map((cat) => (
            <CategoryCard key={cat.title}>
              <h3>{cat.title}</h3>
              <p>{cat.description}</p>
            </CategoryCard>
          ))}
        </Grid>

        <LocationSection>
          <h3>Visit Our Store</h3>
          <LocationCard>
            <h4>Telephone Exchange Square</h4>
            <p>46, Gandhi Grain Market, Central Avenue, Nagpur - 440008</p>
            <p><strong>Call:</strong> 8888865630</p>
          </LocationCard>
        </LocationSection>

        <div style={{ textAlign: 'center', marginTop: '40px', color: '#a1a1aa', padding: '0 8px' }}>
          <p>Email: reetilifestylemall@gmail.com | Website: <strong>www.minggo.in</strong></p>
          <p><small>*Terms & Conditions apply</small></p>
          <ShopButton
            href="https://www.minggo.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            Shop Toys Online at Minggo.in
          </ShopButton>
        </div>
      </Container>
    </FeatureSection>
  );
};

export default MinggoFeature;
